import { NgModule } from '@angular/core';
import { CarouselArrowComponent } from './arrow/carousel-arrow.component';
import { CarouselSlideDirective } from './carousel-slide.directive';
import { CarouselComponent } from './carousel.component';
import { CarouselDotsComponent } from './dots/carousel-dots.component';

const COMPONENTS = [CarouselArrowComponent, CarouselComponent, CarouselDotsComponent, CarouselSlideDirective];

@NgModule({
    imports: COMPONENTS,
    exports: COMPONENTS
})
export class DfUiCarouselModule {}
